/**
 * TaskRecurrenceService
 * Service for task recurrence rules and series control.
 * Route: api/tasks/recurrences
 * Controller: TaskRecurrencesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskRecurrenceService
 * CRUD for recurrence rules plus materialise / cancel / skip-next.
 * Occurrences are materialised by the worker sweep AT their start date; the
 * materialize call exists so the wizard can trigger an immediate pass after
 * attaching a rule.
 */
export class TaskRecurrenceService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskRecurrenceService.DEFAULT_SERVICE_PATH,
            basePath: TaskRecurrenceService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get the recurrences attached to a task (as master).
     * GET /api/tasks/recurrences/by-task/{taskId}
     */
    async getByTask(taskId) {
        const response = await this.getByTaskRaw(taskId);
        return response.data ?? [];
    }
    getByTaskRaw(taskId) {
        return this.http.get(this.buildUrl('by-task/' + taskId));
    }
    /**
     * Run a materialisation pass for one series now. Returns the number of
     * occurrences created (0 or 1 — occurrences spawn at their start date).
     * POST /api/tasks/recurrences/materialize/{id}
     */
    async materialize(id) {
        const response = await this.materializeRaw(id);
        return response.data ?? 0;
    }
    materializeRaw(id) {
        return this.http.post(this.buildUrl('materialize/' + id), {});
    }
    /**
     * Cancel the series — no further occurrences will be created.
     * POST /api/tasks/recurrences/{id}/cancel
     */
    async cancel(id) {
        const response = await this.cancelRaw(id);
        return response.data ?? false;
    }
    cancelRaw(id) {
        return this.http.post(this.buildUrl(id + '/cancel'), {});
    }
    /**
     * Skip the next occurrence (advances the series watermark past it).
     * Returns the skipped occurrence's start, or null when none remains.
     * POST /api/tasks/recurrences/{id}/skip-next
     */
    async skipNext(id) {
        const response = await this.skipNextRaw(id);
        return response.data ?? null;
    }
    skipNextRaw(id) {
        return this.http.post(this.buildUrl(id + '/skip-next'), {});
    }
}
TaskRecurrenceService.DEFAULT_SERVICE_PATH = 'tasks';
TaskRecurrenceService.BASE_PATH = 'api/tasks/recurrences';
//# sourceMappingURL=TaskRecurrenceService.js.map